import React from 'react';

const Vue_v_show = () => {
  return (
    <div>
      <h1>Vue_v_show Component</h1>
      <p>This is the Vue_v_show tutorial page.</p>
    </div>
  );
}

export default Vue_v_show;
